import Crud from '../views/Regiao/Crud'
import Entity from '../views/Regiao/Add'

let routes = {
    path: '/regioes',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/regioes/add',
            name: 'NewRegiao',
            component: Entity
        },
        {
            path: '/regioes/edit/:id?',
            name: 'EditRegiao',
            component: Entity
        },
        {
            path: '/regioes',
            name: 'list-regioes',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Regioes',
                breadcrumb: [
                    {
                        text: 'Regiao',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
